import { Button } from '@travelnest/merlin.button';
import { Modal } from '@travelnest/merlin.modal';
import theme from '@travelnest/merlin.theme';
import React from 'react';
import { Character } from '../../../constants';
import { Paragraph } from '../../paragraph/Paragraph';

interface IPropertyShellIntroductionStepProps {
	onRequestNext: () => any;
	onRequestPrevious: () => any;
	onRequestClose: () => any;
}

export const PropertyShellIntroductionStep: React.FC<IPropertyShellIntroductionStepProps> = (props) => {
	return <Modal
		title="Add a new property"
		onRequestClose={props.onRequestClose}
		shouldCloseOnOverlayClick={false}
		hero={
			<div style={{ background: '#EAF2FF', width: '100%' }}>
				<img src="/92b3b47/assets/images/property-add-hero.svg" style={{ width: '100%', display: 'block' }} />
			</div>
		}
		actionRHS={
			<Button
				onClick={props.onRequestNext}
				bgColor={theme.colours.success.primary}
				color={theme.colours.text.white}
				hoverColor={theme.colours.success.primary}
				className="travelnest-modal__button-align"
			>
				<span>Next</span>
				<span className="travelnest-modal__icon">{Character.Right}</span>
			</Button>
		}>
			<div>
				<h3>Let's get started</h3>
				<Paragraph>We'll ask you some simple questions to better understand your property.</Paragraph>
			</div>
	</Modal>;
};
